import firebase from 'firebase';


var config = {

    apiKey: "AIzaSyAdZsQUzk2kWaZBAS6V91MwE0cnLZmi-Sg",
    authDomain: "islamica500-5992d.firebaseapp.com",
    databaseURL: "https://islamica500-5992d.firebaseio.com",
    projectId: "islamica500-5992d",
    storageBucket: "islamica500-5992d.appspot.com",
    messagingSenderId: "925697942920"
};

var fire = firebase.initializeApp(config);

export default fire;








// WEBPACK FOOTER //
// ./src/components/firebase.js